import { render, staticRenderFns } from "./SoftSkillsMultiselectNew.vue?vue&type=template&id=9a5b0ec0"
import script from "./SoftSkillsMultiselectNew.vue?vue&type=script&lang=ts"
export * from "./SoftSkillsMultiselectNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a5b0ec0')) {
      api.createRecord('9a5b0ec0', component.options)
    } else {
      api.reload('9a5b0ec0', component.options)
    }
    module.hot.accept("./SoftSkillsMultiselectNew.vue?vue&type=template&id=9a5b0ec0", function () {
      api.rerender('9a5b0ec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/SoftSkillsMultiselectNew.vue"
export default component.exports